import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonButtons, IonToggle, IonSegment, IonSegmentButton, IonLabel, IonSearchbar, IonTabBar, IonTabButton, IonIcon, IonTabs, IonBadge, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonSpinner } from '@ionic/react';
import React from 'react';
import { home, barcode, helpCircleOutline, flash, sunny, thumbsUp, cash } from 'ionicons/icons';

const Installation = () => {
  return (
    <IonCard>
      <IonCardHeader>
        <IonLabel color="primary">
          <IonIcon size="small" icon={home} style={{ verticalAlign: 'bottom' }} /> Rua Alagoas 230 Apto 301
        </IonLabel>
        <div style={{ display: 'flex', margin: '10px 0' }}>
          <IonIcon size="small" icon={flash} style={{  alignSelf: 'flex-start', paddingTop: '10px', paddingRight: '5px' }} />
          <div>
            <IonCardTitle>302 kW⋅h</IonCardTitle>
            <IonCardSubtitle>Consumo<br />Dezembro</IonCardSubtitle>
          </div>
          <div style={{ alignSelf: 'stretch', width: '1px', margin: '0 15px', background: 'var(--ion-color-medium)', transform: 'rotate(10deg)' }} />
          <div>
            <IonCardTitle>200 kW⋅h</IonCardTitle>
            <IonCardSubtitle>Capacidade<br />Contratada</IonCardSubtitle>
          </div>
        </div>
        <div style={{ display: 'flex', margin: '10px 0' }}>
          <IonIcon color="success" size="small" icon={cash} style={{ alignSelf: 'flex-start', paddingTop: '10px', paddingRight: '5px' }} />
          <div>
            <IonCardTitle color="success">R$37,00</IonCardTitle>
            <IonCardSubtitle>Valor Economizado</IonCardSubtitle>
          </div>
        </div>
        <IonLabel color="medium">
          <IonIcon size="small" icon={sunny} style={{ verticalAlign: 'bottom' }} /> Fazenda Solar Girassol
        </IonLabel>
      </IonCardHeader>
    </IonCard >
  )
}

const Home: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton>Adicionar</IonButton>
          </IonButtons>
          <IonTitle>Instalações</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar style={{ '--background': 'transparent' }}>
            <IonTitle size="large">Instalações</IonTitle>
          </IonToolbar>
        </IonHeader>
        <div>
          <Installation />
          <Installation />
        </div>
      </IonContent>
      <IonTabBar slot="bottom">
        <IonTabButton tab="schedule">
          <IonIcon icon={home} />
          <IonLabel>Instalações</IonLabel>
        </IonTabButton>

        <IonTabButton tab="speakers">
          <IonIcon icon={barcode} />
          <IonLabel>Contas</IonLabel>
          <IonBadge>2</IonBadge>
        </IonTabButton>

        <IonTabButton tab="about">
          <IonIcon icon={helpCircleOutline} />
          <IonLabel>Ajuda</IonLabel>
        </IonTabButton>

        <IonTabButton tab="dark-mode">
          <IonToggle onIonChange={(e) => { document.body.classList.toggle('dark', e.detail.checked) }}></IonToggle>
        </IonTabButton>
      </IonTabBar>
    </IonPage>
  );
};

export default Home;
